export default __webpack_public_path__ + "static/media/Gustav_Klimt_The_Kiss_35_x_70_cm.2763e4c5.jpg";